import type { ReactElement } from "react";

import Svg, {
  ClipPath,
  Defs,
  G,
  Path,
  Rect,
} from "@/crossPlatform/react-native-svg";

const ExpandIllustrationSVG = ({
  height,
  width,
}: Partial<SizeDimensions>): ReactElement<Partial<SizeDimensions>, "svg"> => (
  <Svg fill="none" height={height} viewBox="0 0 240 240" width={width}>
    <Rect
      fill="#B3FAED"
      height="196.82"
      rx="53"
      width="199.445"
      x="6.00049"
      y="21.5898"
    />
    <G clipPath="url(#clip0_5102_19573)">
      <Path
        d="M216.535 26.1266C195.677 46.7962 174.819 67.4721 153.967 88.1418C151.349 90.738 151.142 95.0566 151.661 98.5266C151.836 99.6936 153.811 106.758 156.316 104.281C177.174 83.6109 198.033 62.9351 218.884 42.2654C221.503 39.6692 221.709 35.3506 221.19 31.8806C221.015 30.7136 219.041 23.649 216.535 26.1266Z"
        fill="#164356"
      />
      <Path
        d="M225.545 176.207C202.15 158.071 178.761 139.935 155.366 121.799C152.579 119.64 151.136 126.374 150.998 127.772C150.673 131.042 150.961 135.822 153.817 138.032C177.212 156.168 200.601 174.303 223.996 192.439C226.783 194.599 228.226 187.865 228.363 186.467C228.688 183.197 228.401 178.416 225.545 176.207Z"
        fill="#164356"
      />
      <Path
        d="M61.0173 42.0289C81.8754 62.6985 102.734 83.3744 123.585 104.044C126.147 106.584 127.935 103.414 128.528 100.911C129.253 97.8532 129.447 91.9556 126.929 89.4592C106.077 68.7833 85.2185 48.1137 64.3666 27.444C61.8046 24.904 60.0175 28.0744 59.4239 30.5769C58.699 33.635 58.5053 39.5325 61.0235 42.0289H61.0173Z"
        fill="#164356"
      />
      <Path
        d="M56.8059 192.932C80.201 174.796 103.59 156.66 126.985 138.524C129.791 136.346 129.759 131.291 129.291 128.139C129.072 126.66 127.404 120.238 124.635 122.385C101.24 140.521 77.8515 158.657 54.4564 176.793C51.6507 178.971 51.6819 184.026 52.1506 187.177C52.3693 188.657 54.0377 195.078 56.8059 192.932Z"
        fill="#164356"
      />
      <Path
        d="M55.9686 36.9739C57.6683 48.1325 58.3369 59.3286 58.0745 70.612C58.0245 72.8338 58.7806 78.8749 61.9486 78.9123C65.1167 78.9498 65.3667 72.2659 65.4104 70.4311C65.7104 57.6935 64.848 44.931 62.9359 32.337C62.6235 30.2775 61.3675 25.0914 58.2807 26.5829C55.3688 27.9871 55.6062 34.5587 55.9749 36.9677L55.9686 36.9739Z"
        fill="#164356"
      />
      <Path
        d="M59.1304 40.5554C70.0219 40.5554 80.9196 40.5554 91.8111 40.5554C96.885 40.5554 96.6663 23.7676 91.3987 23.7676C80.5072 23.7676 69.6095 23.7676 58.718 23.7676C53.644 23.7676 53.8627 40.5554 59.1304 40.5554Z"
        fill="#164356"
      />
      <Path
        d="M180.061 41.6294C193.133 40.5498 206.206 39.4639 219.278 38.3842C224.564 37.9473 223.871 21.1844 218.865 21.5963C205.793 22.676 192.721 23.7619 179.649 24.8416C174.362 25.2784 175.056 42.0413 180.061 41.6294Z"
        fill="#164356"
      />
      <Path
        d="M216.197 37.1484V66.5241C216.197 68.752 216.866 74.7869 220.071 74.8244C223.277 74.8618 223.533 68.1779 223.533 66.3431V36.9675C223.533 34.7395 222.865 28.7046 219.659 28.6671C216.453 28.6297 216.197 35.3136 216.197 37.1484Z"
        fill="#164356"
      />
      <Path
        d="M219.472 146.288C220.984 159.4 223.09 172.424 225.783 185.349C226.202 187.371 227.283 192.626 230.438 191.103C233.257 189.743 233.238 183.071 232.744 180.718C230.051 167.8 227.945 154.769 226.433 141.657C226.195 139.573 224.821 134.436 221.778 135.903C218.735 137.37 219.184 143.841 219.472 146.288Z"
        fill="#164356"
      />
      <Path
        d="M228.495 175.764C215.173 177.299 201.776 177.555 188.403 176.531C183.592 176.163 183.367 192.901 188.816 193.319C202.188 194.343 215.585 194.087 228.907 192.552C234.263 191.934 233.382 175.202 228.495 175.764Z"
        fill="#164356"
      />
      <Path
        d="M55.8624 198.998L91.8049 200.034C96.7851 200.177 96.7351 183.402 91.3925 183.246L55.45 182.21C50.4698 182.066 50.5198 198.842 55.8624 198.998Z"
        fill="#164356"
      />
      <Path
        d="M58.3619 186.51C57.3371 177.742 58.1619 169.024 60.3615 160.492C61.2113 157.191 61.1926 151.743 58.7618 149.04C56.3311 146.338 54.4065 149.883 53.8191 152.173C50.5323 164.923 49.8762 178.091 51.4009 191.141C51.6446 193.219 53.013 198.362 56.0561 196.895C59.0992 195.429 58.6493 188.957 58.3619 186.51Z"
        fill="#164356"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_5102_19573">
        <Rect
          fill="white"
          height="178.45"
          transform="translate(50.6133 21.5898)"
          width="182.387"
        />
      </ClipPath>
    </Defs>
  </Svg>
);

export default ExpandIllustrationSVG;
